import React from 'react';
import { FaClock } from 'react-icons/fa';
import * as S from '../GraciasPage.styles';
import PaymentCode from './PaymentCode';
import WhatsAppButton from './WhatsAppButton';
import { generatePendingPaymentMessage } from '../utils';

/**
 * Estado de pago pendiente
 */
const PendingState = ({ t, paymentId }) => {
  return (
    <>
      <S.StatusIcon $status="pending">
        <FaClock />
      </S.StatusIcon>
      <S.Title>{t('gracias.pending.title')}</S.Title>
      <S.Message>{t('gracias.pending.message')}</S.Message>
      <S.SubMessage>{t('gracias.pending.submessage')}</S.SubMessage>
      
      <PaymentCode 
        label={t('gracias.pending.paymentCode')} 
        code={paymentId} 
      />
      
      <S.ButtonGroup>
        <WhatsAppButton 
          href={generatePendingPaymentMessage(paymentId)}
          label="WhatsApp"
        />
      </S.ButtonGroup>
    </>
  );
};

export default PendingState;

